<template>
  <el-container class="login-page">
    <el-header>
      <h1>月亮湾</h1>
      <el-button class="register" plain>注册</el-button>
    </el-header>
    <el-main>
      <div class="box">
        <div class="main">
          <div class="left"><img src="../assets/pic_login.jpg" alt=""></div>
          <div class="right" v-if="type == 'forget'">
            <h3>欢迎使用月亮湾魔盒</h3>
            <h4>忘记密码</h4>
            <div class="row">
              <el-input placeholder="请输入手机号" v-model="phone">
                <!-- <template slot="prepend">+86</template> -->
                <el-input class="area_code" slot="prepend" v-model="area_code" :disabled="true"></el-input>
              </el-input>
            </div>
            <div class="row">
              <el-input placeholder="请输入验证码" v-model="code" class="">
                <el-button slot="append" :type="second <= 0 ? 'success' : 'info'" @click="getCode">{{ second <= 0 ? '发送验证码' : second + 's' }}</el-button>
              </el-input>
            </div>
            <el-button class="login" type="success" @click="toNew">重置密码</el-button>
            <div class="row">记起密码？<span class="green" @click="toLogin">立即登录</span></div>
          </div>
          <div class="right" v-else-if="type == 'new'">
            <h3>欢迎使用月亮湾魔盒</h3>
            <h4>设置新密码</h4>
            <div class="row">
              <div class="label">新密码</div>
              <el-input placeholder="请输入新密码" v-model="npsw" show-password></el-input>
            </div>
            <div class="row">
              <div class="label">确认新密码</div>
              <el-input placeholder="请再次输入新密码" v-model="apsw" show-password></el-input>
            </div>
            <el-button class="login" type="success" @click="toReset">重置密码</el-button>
          </div>
          <div class="right" v-else-if="type == 'choice'">
            <h3>欢迎使用月亮湾魔盒</h3>
            <div class="row">
              <el-radio-group v-model="choiceValue">
                <el-radio-button class="w50 h60" label="管理端"></el-radio-button>
                <el-radio-button class="w50 h60" label="客户端"></el-radio-button>
              </el-radio-group>
            </div>
            <div class="row" v-if="choiceValue == '客户端'">
              <el-select v-model="customerValue" placeholder="请选择客户">
                <el-option
                  v-for="item in customerOptions"
                  :key="item.client_id"
                  :label="item.client_name"
                  :value="item.client_id">
                </el-option>
              </el-select>
            </div>
            <el-button class="login" type="success" @click="choiceClick">确认</el-button>
          </div>
          <div class="right" v-else>
            <h3>欢迎使用月亮湾魔盒</h3>
            <h4></h4>
            <div class="row">
              <el-input placeholder="请输入手机号" v-model="phone">
                <!-- <template slot="prepend">+86</template> -->
                <el-input class="area_code" slot="prepend" v-model="area_code" :disabled="true"></el-input>
              </el-input>
            </div>
            <div class="row">
              <el-input placeholder="请输入密码" v-model="psw" show-password></el-input>
            </div>
            <el-row>
              <el-col :span="4" :offset="20">
                <el-link type="success" @click="toForget">忘记密码</el-link>
              </el-col>
            </el-row>
            <div class="row agreement-row">
              <el-checkbox v-model="agreeProtocol">
                我已阅读并同意
                <el-link type="success" @click="showUserAgreement">《用户服务协议》</el-link>
                和
                <el-link type="success" @click="showPrivacyPolicy">《隐私协议》</el-link>
              </el-checkbox>
            </div>
            <el-button class="login" type="success" @click="goLogin">登录</el-button>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>
  
<script>
// user:13570997060
// psw:111111
let _ajaxType = 0

export default {
  name: 'Login',
  data() {
    return {
      type: '',
      choiceValue: '管理端',
      area_code: '86',
      phone: '',
      psw: '',
      npsw: '',
      apsw: '',
      code: '',
      code_r: '',
      customerOptions: [
        // {
        //   value: '客户A',
        //   label: '客户A',
        // },
        // {
        //   value: '客户B',
        //   label: '客户B',
        // },
        // {
        //   value: '客户C',
        //   label: '客户C',
        // }
      ],
      customerValue: '',
      second: 0,
      agreeProtocol: false
    }
  },
  mounted() {
    console.log(localStorage)
    const token = localStorage.getItem('sessionId');
    console.log('token', token)
    if (token) {
      this.type = 'choice'
      this.getClient()
    }
    const _phone = localStorage.getItem('phone');
    if(_phone){
      this.phone = _phone
    }
  },
  methods: {
    goLogin() {
      // 验证是否同意协议
      if (!this.agreeProtocol) {
        this.$message({
          message: '请先阅读并同意《用户服务协议》和《隐私协议》',
          type: 'warning',
          offset: 300
        });
        return;
      }

      if(_ajaxType == 1) return
      _ajaxType = 1
      let _phone = this.phone
      let _psw = this.psw
      console.log(_phone, _psw)
      const _url = "/api/?mod=login"
      // console.log(_url)
      let loginData = {
        phone: _phone,
        password: _psw
      }
      this.axios.post(_url, loginData).then(json => {
        _ajaxType = 0
        // 获取
        let _data = json.data.data
        console.log("login", _data);
        if (json.data.errcode == 0) {
          localStorage.setItem('phone', _phone)
          localStorage.setItem('username', _data.username)
          localStorage.setItem('sessionId', _data.session_id)
          this.getUser()
          // 直接跳转到管理端
          this.global.type = 'manage'
          this.$router.replace('/')
        }
        console.log(json.data);
      })
    },
    getClient() {
      const _url = "/api/?mod=client&action=all"
      // console.log(_url)
      this.axios.post(_url).then(json => {
        // 获取
        let _data = json.data.data
        console.log("clientData", _data);
        if (json.data.errcode == 0) {
          this.customerOptions = _data.result
          // localStorage.setItem('phone', _phone)
          // localStorage.setItem('sessionId', _data.session_id)
          // this.type = 'choice'
        }
        console.log(json.data);
      })
    },
    getUser() {
      const _url = "/api/?mod=user"
      // console.log(_url)
      this.axios.post(_url).then(json => {
        // 获取
        let _data = json.data.data
        console.log("checklogin", _data);
        if(_data.login == 1){
          this.global.money = _data.user.money
          console.log('user', this.global)
          return
        }
        localStorage.removeItem('sessionId');
        if(_path != '/login'){
          this.$router.replace('/login')
          // window.location.href = '/login'
        }
        console.log(json.data);
      })
    },
    choiceClick() {
      let _type = this.choiceValue
      if(_type == '管理端'){
        this.global.type = 'manage'
        this.$router.replace('/')
      }
      if(_type == '客户端'){
        let _client_id = this.customerValue
        console.log('client_id', _client_id)
        this.global.type = 'client'
        this.global.clientId = _client_id
        let _client = this.customerOptions.find(c => c.client_id === _client_id);
        console.log(_client)
        this.global.clientName = _client.client_name
        console.log(this.global)
        this.$router.replace('/client')
      }
    },
    toForget() {
      this.type = 'forget'
    },
    toNew() {
      if(_ajaxType == 1) return
      _ajaxType = 1
      let _phone = this.phone
      let _code = this.code
      // console.log(_phone, _psw)
      const _url = "/api/?mod=user&action=verify"
      // console.log(_url)
      let loginData = {
        phone: _phone,
        vcode: _code
      }
      this.axios.post(_url, loginData).then(json => {
        _ajaxType = 0
        // 获取
        let _data = json.data.data
        console.log("login", _data);
        if (json.data.errcode == 0) {
          this.code_r = _data.code
          this.type = 'new'
        }
        console.log(json.data);
      })
    },
    toLogin() {
      this.type = ''
    },
    getCode() {
      if(_ajaxType == 1) return
      let _second = this.second
      if(_second > 0) return
      _ajaxType = 1
      let _this = this
      let _phone = this.phone
      const _url = "/api/?mod=send"
      // console.log(_url)
      let loginData = {
        phone: _phone,
      }
      this.axios.post(_url, loginData).then(json => {
        // 获取
        let _data = json.data.data
        console.log("login", _data);
        if (json.data.errcode == 0) {
          this.$message({
            message: '发送验证码成功',
            type: 'success',
            offset: 300,
            onClose: function() {
              _ajaxType = 0
              _this.second = 61
              _this.waitCode()
            }
          });
        }else{
          _ajaxType = 0
        }
        console.log(json.data);
      })
    },
    waitCode(){
      let _second = this.second - 1
      this.second = _second
      if(_second <= 0){
        return
      }
      // 发送验证码
      setTimeout(this.waitCode, 1000)
    },
    toReset() {
      if(_ajaxType == 1) return
      _ajaxType = 1
      let _this = this
      let _phone = this.phone
      let _code = this.code_r
      let _npsw = this.npsw
      let _apsw = this.apsw
      console.log(_phone, _npsw)
      const _url = "/api/?mod=user&action=reset"
      // console.log(_url)
      let loginData = {
        phone: _phone,
        code: _code,
        password: _npsw,
        cfm_password: _apsw
      }
      this.axios.post(_url, loginData).then(json => {
        // 获取
        let _data = json.data.data
        console.log("login", _data);
        if (json.data.errcode == 0) {
          this.$message({
            message: '重置成功',
            type: 'success',
            offset: 300,
            onClose: function() {
              _ajaxType = 0
              _this.type = ''
            }
          });
        }else{
          _ajaxType = 0
        }
        console.log(json.data);
      })
    },
    showUserAgreement() {
      // 打开用户服务协议
      this.$alert(`
        <div style="max-height: 400px; overflow-y: auto; text-align: left; line-height: 1.8;">
          <h3 style="text-align: center;">用户服务协议</h3>
          <p><strong>一、服务概述</strong></p>
          <p>1.本协议由用户（以下简称 "用户"）与月亮湾魔盒平台（以下简称 "平台"，平台链接：https://mohe.s110.ylwai.cn）共同签署，平台专为公装装修行业的相关从业人员或有公装装修需求的客户提供空间概念效果图 AI 生成服务，用户完成注册并登录后，可依法使用平台提供的各项功能及服务。</p>
          <p>2.平台有权根据技术发展、业务需求等情况调整服务内容、功能模块或操作流程，调整后将通过平台公告、站内信等合理方式通知用户，用户继续使用平台服务即视为认可并接受调整后的服务及本协议条款。</p>
          <p>3.现阶段平台为邀请制注册使用，暂时未提供付费入口。后续若提供的部分服务可能需用户支付相应费用，具体收费标准、支付方式及服务期限将在服务页面明确标注，用户支付费用后即视为同意相关收费规则，平台将按照约定提供对应服务。</p>
          <p><strong>二、用户账号管理</strong></p>
          <p>1.用户申请账号时需提供真实、准确、完整的个人信息（包括但不限于姓名、手机号、邮箱），并保证信息持续有效。若信息存在虚假、错误或失效，平台有权拒绝提供服务或暂停、注销用户账号，由此造成的损失由用户自行承担。</p>
          <p>2.账号及密码由用户自行保管，用户应对账号下的所有操作、行为及产生的后果承担全部责任。严禁将账号出租、出借、转让给第三方使用，若发现账号异常登录、泄露等情况，应立即通知平台并修改密码，平台未收到通知前因账号被冒用导致的损失，平台不承担责任。</p>
          <p><strong>三、用户权利与义务</strong></p>
          <p>用户有权在遵守本协议及平台规则的前提下，使用平台提供的 AI 生成效果图、AI改图、图生视频、素材管理、作品导出等服务功能。</p>
          <p><strong>四、知识产权</strong></p>
          <p>平台通过 AI 技术生成的图片和视频作品，其知识产权归平台所有，用户获得在公装装修设计业务、商务洽谈、项目展示等合法场景下的非独占使用权。</p>
          <p style="text-align: center; margin-top: 20px;">平台客服联系方式：896021759@qq.com</p>
          <p style="text-align: center;">协议更新时间：2026年1月1日</p>
        </div>
      `, '用户服务协议', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '我已阅读',
        customClass: 'agreement-dialog'
      });
    },
    showPrivacyPolicy() {
      // 打开隐私协议
      this.$alert(`
        <div style="max-height: 400px; overflow-y: auto; text-align: left; line-height: 1.8;">
          <h3 style="text-align: center;">隐私协议</h3>
          <p><strong>一、隐私政策概述</strong></p>
          <p>月亮湾魔盒平台（以下简称 "平台"，平台链接：https://mohe.s110.ylwai.cn）尊重并保护用户的隐私及合法权益，本隐私协议旨在说明平台如何收集、使用、存储、保护用户信息，以及用户对个人信息享有的权利。用户使用平台服务，即视为同意平台按照本协议约定处理其信息。</p>
          <p><strong>二、信息收集范围与方式</strong></p>
          <p>1.注册信息：用户注册时提供的姓名、手机号、邮箱、账号密码等，用于账号注册、身份核验、登录验证及服务对接。</p>
          <p>2.使用过程中提供的信息：用户上传的设计素材（图片、文字、草图等）、生成效果图的相关参数设置、提交的咨询内容、投诉举报信息等，用于提供精准服务、处理用户需求。</p>
          <p><strong>三、信息使用目的与方式</strong></p>
          <p>1.提供基础服务：包括账号登录、生成效果图、生成视频、素材存储、作品管理等，确保平台服务正常运行。</p>
          <p>2.优化服务体验：根据用户使用行为及需求，优化 AI 算法模型、调整功能模块、推荐相关服务或内容，提升服务精准度和实用性。</p>
          <p><strong>四、信息存储与保护</strong></p>
          <p>平台采用加密技术、访问权限控制、安全审计、数据备份等多种安全措施，保护用户信息免受泄露、篡改、丢失或非法访问。</p>
          <p><strong>五、用户信息权利</strong></p>
          <p>用户有权查询、修改、删除自己的信息，也可申请注销账号。若用户认为平台处理其信息的行为违反法律法规或本协议约定，可向平台客服投诉。</p>
          <p style="text-align: center; margin-top: 20px;">平台客服联系方式：896021759@qq.com</p>
          <p style="text-align: center;">协议更新时间：2026年1月1日</p>
        </div>
      `, '隐私协议', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '我已阅读',
        customClass: 'agreement-dialog'
      });
    }
  }
}
</script>
  
<style scoped lang="less">
h1 {
  height: 60px;
  line-height: 60px;
  font-size: 24px;
  font-weight: normal;
}

.register {
  position: absolute;
  top: 50%;
  margin-top: -20px;
  right: 20px;
}

.box {
  text-align: center;
  margin-top: 60px;
  .main {
    position: relative;
    display: inline-block;
    width: 1000px;
    height: 596px;
    padding-left: 510px;
    padding-right: 80px;
    box-sizing: border-box;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 6px 0px;
    .left {
      position: absolute;
      top: 0;
      left: 0;
      width: 448px;
      height: 100%;
      img {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
      }
    }
    .right {
      width: 100%;
      height: 100%;
      h3 {
        height: 40px;
        margin-top: 30px;
        margin-bottom: 40px;
        color: rgba(80,184,92,1);
        font-size: 36px;
        line-height: 40px;
        font-weight: 400;
        text-align: left;
      }
      h4 {
        font-size: 24px;
      }
      .row {
        margin-top: 20px;
        .label {
          margin-bottom: 8px;
          text-align: left;
          font-weight: 600;
        }
        .area_code {
          position: relative;
          width: 80px;
          &::before {
            position: absolute;
            content: '+';
            top: 0;
            left: 28px;
            color: #606266;
            font-size: 14px;
            line-height: 59px;
            opacity: 0.4;
          }
        }
        .el-radio-group {
          width: 100%;
        }
        .w50 {
          width: 50%;
        }
        .h60 {
          height: 60px;
        }
      }
      .el-row {
        margin-top: 10px;
      }
      .el-select {
        width: 100%;
      }
      .login {
        width: 100%;
        margin-top: 20px;
      }
      .agreement-row {
        text-align: left;
        font-size: 14px;
        color: #606266;
        .el-checkbox {
          line-height: 1.6;
        }
        .el-link {
          font-size: 14px;
          vertical-align: baseline;
        }
      }
    }
  }
}

.el-input-group__append button.el-button {
  height: 58px;
  // color: rgb(10, 92, 10);
  // background-color: rgb(215, 247, 219);
  // border-color: rgb(215, 247, 219);
}
</style>


// WEBPACK FOOTER //
// src/views/Login.vue